/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForum = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 2v3.999h5v16h-3.536l-2-3H7v-3.197l-1.465 2.197H2V2zm3 6h-3v7H9v2h8.535l2 3H20zm-5-4H4v11.999h.465l2-2.999H15z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgForum as Forum };
